import React, { useState, useEffect } from 'react';
import { Container, Carousel } from 'react-bootstrap';

interface Testimonial {
  id: number;
  name: string;
  text: string;
  created_at: string;
  updated_at: string;
}

const API_URL = process.env.REACT_APP_API_URL

const TestimonialSection: React.FC = () => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await fetch(`${API_URL}/api/testimonials`);
        if (!res.ok) throw new Error('Failed to fetch testimonials');
        const data: Testimonial[] = await res.json();
        setTestimonials(data);
      } catch (err) {
        console.error('Error fetching testimonials:', err);
      }
    };
    fetchTestimonials();
  }, []);

  return (
    <section className="testimonial-section py-5">
      <Container>
        <h2 className="text-center mb-5 section-title">What People Say</h2>
        {testimonials.length > 0 ? (
          <Carousel indicators={true} controls={true} interval={3000} pause="hover">
            {testimonials.map((testimonial) => (
              <Carousel.Item key={testimonial.id}>
                <div className="testimonial-box text-center fade-in-up">
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <h4 className="testimonial-name">- {testimonial.name}</h4>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <p className="text-center">No testimonials available.</p>
        )}
      </Container>
    </section>
  );
};

export default TestimonialSection;